import { render } from "./Agents.vue?vue&type=template&id=8f4944c8"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Agents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f4944c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f4944c8', __exports__)) {
    api.reload('8f4944c8', __exports__)
  }
  
  module.hot.accept("./Agents.vue?vue&type=template&id=8f4944c8", () => {
    api.rerender('8f4944c8', render)
  })

}


export default __exports__